var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.715,
    height: 29.2,
    viewBox: "0 0 29.715 29.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_clock_1814097",
    transform: "translate(-9 -9.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Clock",
    transform: "translate(9 9.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-131",
    d: "M-354.143-389.7A14.769,14.769,0,0,1-369-404.3a14.769,14.769,0,0,1,14.857-14.6,14.769,14.769,0,0,1,14.857,14.6,14.686,14.686,0,0,1-14.857,14.6Zm0-27.67a13.136,13.136,0,0,0-13.235,13.006,13.177,13.177,0,0,0,13.235,13.006,13.177,13.177,0,0,0,13.235-13.006,13.136,13.136,0,0,0-13.235-13.006Z",
    transform: "translate(369 418.9)",
    fill: "#4d6a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-132",
    d: "M-341.885-393l-5.515-5.419V-408.3h1.752v9.181l5,4.909L-341.885-393",
    transform: "translate(361.414 415.058)",
    fill: "#4d6a75"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEta);
export default __webpack_public_path__ + "static/media/eta.2c1b8e95a5c0577a2dec7521af01d726.svg";
export { ForwardRef as ReactComponent };